import Img, { FluidObject } from 'gatsby-image';
import * as React from 'react';
import { ContentfulArticleSection, Maybe } from '../types/graphql-types';
import { ServiceArticleSection, ServiceArticleSectionImage } from './Sections';

export interface IArticleSection {
  section?: Maybe<ContentfulArticleSection>;
}

export const ArticleSection = ({ section }: IArticleSection) => {
  if (!section) {
    return null;
  }

  return (
    <ServiceArticleSection>
      {section.text && (
        <div
          dangerouslySetInnerHTML={{
            __html: section!.text!.childContentfulRichText!.html as string
          }}
        />
      )}

      {section.image && section.image.fluid && section.image.fluid.aspectRatio && (
        <ServiceArticleSectionImage>
          <Img fluid={section.image!.fluid as FluidObject} />
        </ServiceArticleSectionImage>
      )}
    </ServiceArticleSection>
  );
};
